module.exports = __webpack_public_path__ + "static/media/client3.b009ebf0.jpg";